import { getPPIDLoggedInStatus } from '@schibsted/advertory/tracker/es';

import { getAssetProvider } from '../../utils/player/player';

import { GetAdnSettings } from './types';
import { PpidWrapper } from './ppid/PpidWrapper';

let ppidWrapper: PpidWrapper | null = null;

export const withPPID =
  (getSettings: GetAdnSettings): GetAdnSettings =>
  async (context, options, stream, defaults, player) => {
    const provider = getAssetProvider(player);
    if (provider === 'brandstudio') {
      return null;
    }

    ppidWrapper = ppidWrapper || new PpidWrapper(player);

    const settings = await getSettings(
      context,
      options,
      stream,
      defaults,
      player
    );

    await ppidWrapper.ready;
    if (!ppidWrapper.tracker) {
      return settings || null;
    }

    if (!settings) {
      return null;
    }

    const eids: string = await ppidWrapper.getEids();
    const ppidKeywords = getPPIDLoggedInStatus();
    settings.adSlots.params = {
      ...settings.adSlots.params,
      ...ppidKeywords,
      eids,
    };

    // PPID for display ads
    if (settings.adPlacements) {
      settings.adPlacements.params.keywords = {
        ...settings.adPlacements.params.keywords,
        ...ppidKeywords,
      };
    }

    return settings;
  };
